import { Dealer, ModelConfig } from "../typing/model";
import { Offer } from "../typing/offer";

export function getAppliedFilterList(store: any, event: any) {
    const filterList: any[] = [
        {
            type: 'single_value',
            name: 'ZIP',
            values: [store.zip],
        },
    ];

    return {
        ...event,
        filterlist: filterList,
    };
}

export function getResultsFilterData(offers: Offer[], event: any) {
    const filterResults: any[] = [];
    offers.map((offer: Offer) => {
        filterResults.push({
            campaignId: `${offer.dealId}`
        });
    });

    return {
        ...event,
        results: filterResults,
        numberOfResults: offers?.length
    };
}

export function getDealerData(dealer?: Dealer, eventObject?: any) {
    return {
        ...eventObject,
        informationBnr: dealer?.dealerid,
        informationName: dealer?.name,
        informationDistance: dealer?.distance,
        informationZIP: dealer?.postalcode
    };
}

export function getConfigurationData(offer?: Offer, model?: ModelConfig, event?: any) {
    return {
        ...event,
        CarlineName:
            (offer?.dealCarModelName?.length && offer?.dealCarModelName[0]) ||
            model?.name ||
            undefined,
        CarlineId: model?.carlineId,
        SalesgroupName:
            (offer?.dealCarTrim?.length && offer?.dealCarTrim[0]) ||
            undefined,
        PriceCampaignID: [offer?.dealId ? `${offer?.dealId}` : undefined],
        PriceCampaignDescription: [offer?.dealTitle],
        PriceCampaignValue: offer?.dealPricePerMonth
            ? [offer?.dealPricePerMonth]
            : undefined
    };
}